import React from 'react'
import { Link } from 'react-router-dom'

export default function RightSection() {
    return (
        <div className='case_studies'>

            <h4 className='sub-heading text-white'>Recent Post</h4>
            <hr />
            <div className='recent-post'>
                <ul>
                    <li>
                        <Link target="_blank" to='/blog/zero-trust-blog'>
                            <div className='thumb-box'>
                                <img src={require('../../assets/images/blog/zero-trust-blog.png')} alt='' />
                            </div>
                            <div className='details-box'>
                                <span>17 June 2021</span>
                                <p>What is Zero Trust Architecture?...</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link target="_blank" to={"/"}>
                            <div className='thumb-box'>
                                <img src={require('../../assets/images/blog/ransomware-stats.webp')} alt='' />
                            </div>
                            <div className='details-box'>
                                <span>Dec 05 2020</span>
                                <p>Ransomware Statistics, Data, Trends, and Facts...</p>
                            </div>
                        </Link>
                    </li>
                    {/* 
                    <li>
                        <Link target="_blank" to={"/"}>
                            <div className='thumb-box'>
                                <img src={require('../../assets/images/blog/zero-trust-blog.png')} alt='' />
                            </div>
                            <div className='details-box'>
                                <span>26 September 2019</span>
                                <p>19th Eventus Corporate Cricket Tournament Set...</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link target="_blank" to="/">
                            <div className='thumb-box'>
                                <img src={require('../../assets/images/blog/zero-trust-blog.png')} alt='' />
                            </div>
                            <div className='details-box'>
                                <span>6 Feb 2024</span>
                                <p> Brand Street Integrated: Pioneering Experiential Marketing and Innovation...</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link target="_blank" to="">
                            <div className='thumb-box'>
                                <img src={require('../../assets/images/blog/zero-trust-blog.png')} alt='' />
                            </div>
                            <div className='details-box'>
                                <span>11 Sep 2019</span>
                                <p> BrandStreet India acquires 17 fortune blue chip firm projects...</p>
                            </div>
                        </Link>
                    </li> */}


                </ul>
            </div>
        </div >


    )
}
